<hw-page-header header="term.cs-01.header" class="page-header"></hw-page-header>
<nz-content class="main">
  <hw-table header="term.cs-01.header" *ngIf="items">
    <div headerContent>
      <div style="display: flex">
        <nz-input-group [nzSuffix]="inputClear">
          <input
            nz-input
            name="filter"
            [(ngModel)]="search"
            (ngModelChange)="onSearchChange($event)"
            placeholder="{{ 'term.cs-01.quick-search' | translate }}" />
        </nz-input-group>
        <ng-template #inputClear>
          <i
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="search"
            (click)="clearSearch()"></i>
        </ng-template>
        <hw-button [routerLink]="['/codesystems/add']" display="secondary" label="core.btn.add"></hw-button>
      </div>
    </div>
    <nz-table
      #basicTable
      [nzData]="items | textSearch : { '*': search }"
      nzSize="small"
      nzFrontPagination="false"
      nzShowPagination="false">
      <thead>
        <tr>
          <th>{{ 'term.cs-01.id' | translate }}</th>
          <th>{{ 'term.cs-01.name' | translate }}</th>
          <th>{{ 'term.cs-01.description' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of basicTable.data">
          <td>
            <a [routerLink]="['/codesystems/view', row.id]">{{ row.id }}</a>
          </td>
          <td>{{ row.names | localName }}</td>
          <td>{{ row.title | localName }}</td>
        </tr>
      </tbody>
    </nz-table>
  </hw-table>
</nz-content>
